// this is an autogenerated file from DesignSystem/AutomationTask/Board/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_AutomationTask_Board($location_id: uuid!) {
  tasks_boards(
    where: {
      status: { _eq: active }
      type: { _neq: PRIVATE }
      metadata: { _contains: { locations: [$location_id] } }
    }
    order_by: { name: asc }
  ) {
    id
    text: name
  }
}

`